import React from 'react';
import Route from 'react-router/lib/Route';
import IndexRoute from 'react-router/lib/IndexRoute';
import BuoyweatherPageContainer from '../containers/routes/BuoyweatherPageContainer';

const importNotFound = (nextState, cb) => {
  System.import('../containers/routes/NotFound/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importHomePage = (nextState, cb) => {
  System.import('../containers/routes/HomePage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importForecastPage = (nextState, cb) => {
  System.import('../containers/routes/ForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importPrintForecastPage = (nextState, cb) => {
  System.import('../containers/routes/PrintForecastPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const importMapPage = (nextState, cb) => {
  System.import('../containers/routes/MapPage/index.js')
    .then(module => cb(null, module.default))
    .catch((e) => { throw e; });
};

const routes = (
  <Route path="/" component={BuoyweatherPageContainer}>
    <IndexRoute getComponent={importHomePage} />
    <Route path="forecast/marine-weather/print/(*)@*,*" getComponent={importPrintForecastPage} />
    <Route path="forecast/marine-weather/(*)@*,*" getComponent={importForecastPage} />
    <Route path="/map/:id" getComponent={importMapPage} />
    <Route path="*" getComponent={importNotFound} status={404} />
  </Route>
);

if (module.hot) {
  /* eslint-disable global-require */
  require('../containers/routes/ForecastPage/index.js');
  /* eslint-enable global-require */
}

export default routes;



// WEBPACK FOOTER //
// ./src/routes/index.js